/* global airShowLogoURL, jalapenoFestivalLogoURL */
// jalapenoFestivalLogoURL & airShowLogoURL are defined in Spark under a widget named "Logos URLs"

$(document).ready(function () {
  topBanner();
  logosUrls();
});

// Create Subpage Top Banner
function topBanner() {
  if ($('body').hasClass('subpage')) {
    const topRow = $('.entityContainerRow.rowIndex-1');
    const bannerImage = topRow.find('.imageModule-single').first().find('img');
    const bannerImagePath = bannerImage.attr('src')
      ? bannerImage.attr('src')
      : bannerImage.attr('data-src');

    if (bannerImagePath) {
      const cleanImgPath = bannerImagePath.replaceAll(/(?=[() ])/g, '\\');

      topRow.find('.TextMediaModule').first().hide();
      $('<div class="hero-image"></div>')
        .css('background-image', `url(${cleanImgPath})`)
        .insertAfter('header');
    }
  }
}

function logosUrls() {
  const logo = $('.header-logo');

  switch (true) {
    case $('body').hasClass('jalapeno-fest'):
      logo.attr('href', jalapenoFestivalLogoURL).attr('aria-label', 'Jalapeño Festival');
      break;

    case $('body').hasClass('air-show'):
      logo.attr('href', airShowLogoURL).attr('aria-label', 'Stars & Stripes Air Show Spectacular');
      break;

    default:
      logo.attr('href', '/');
  }
}
